import React from 'react';
import { motion } from 'framer-motion';

const StatsCard = ({ icon: Icon, label, value, subtitle, delay = 0 }) => {
  return (
    <motion.div
      className="glassmorphic p-6"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay, duration: 0.3, ease: 'easeOut' }}
    >
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-muted-foreground">{label}</p>
        <Icon className="h-5 w-5 text-primary" />
      </div>
      <p className="text-3xl font-light text-foreground mb-1">{value}</p>
      {subtitle && (
        <p className="text-xs text-body">{subtitle}</p>
      )}
    </motion.div>
  );
};

export default StatsCard;

